export const MODULES = ["tenants", "branches", "users", "roles", "customers", "vehicles", "settings"];

export const ROLE_LABELS = {
  super_admin: "Super Admin VRIntegrales",
  dueno: "Dueño",
  gerente: "Gerente",
  recepcion: "Recepción",
  tecnico: "Técnico",
  mecanico: "Mecánico",
  hojalatero: "Hojalatero",
  administrador: "Administrador",
  almacen: "Almacén",
  caja: "Caja",
  consulta: "Consulta / Auditor",
};

export const ENGINE_TYPES = [
  { value: "gasoline", label: "Gasolina" },
  { value: "diesel", label: "Diésel" },
  { value: "hybrid", label: "Híbrido" },
  { value: "electric", label: "Eléctrico" },
];

export const TRANSMISSIONS = [
  { value: "manual", label: "Manual" },
  { value: "automatic", label: "Automática" },
  { value: "cvt", label: "CVT" },
];

export const BRANCH_TYPES = [
  { value: "workshop", label: "Taller" },
  { value: "warehouse", label: "Almacén" },
  { value: "office", label: "Oficina" },
];

export const CUSTOMER_TYPES = [
  { value: "individual", label: "Persona física" },
  { value: "company", label: "Persona moral" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Activo" },
  { value: "inactive", label: "Inactivo" },
];

export const ACCOUNT_STATUS = [
  { value: "active", label: "Activo" },
  { value: "trial", label: "Prueba" },
  { value: "suspended", label: "Suspendido" },
];

export const PLANS = [
  { value: "starter", label: "Starter" },
  { value: "pro", label: "Pro" },
  { value: "enterprise", label: "Enterprise" },
];

// ==== Fase 2: operational constants ====
export const SERVICE_ORDER_STATUSES = [
  { value: "recibido", label: "Recibido", tone: "slate" },
  { value: "en_diagnostico", label: "En diagnóstico", tone: "blue" },
  { value: "pendiente_autorizacion", label: "Pendiente autorización", tone: "amber" },
  { value: "autorizado", label: "Autorizado", tone: "teal" },
  { value: "en_proceso", label: "En proceso", tone: "indigo" },
  { value: "pausa", label: "Pausa", tone: "yellow" },
  { value: "listo_para_entrega", label: "Listo para entrega", tone: "emerald" },
  { value: "entregado", label: "Entregado", tone: "green" },
  { value: "cancelado", label: "Cancelado", tone: "red" },
];

export const STATUS_COLORS = {
  slate: "bg-slate-100 text-slate-800 hover:bg-slate-100",
  blue: "bg-blue-100 text-blue-800 hover:bg-blue-100",
  amber: "bg-amber-100 text-amber-800 hover:bg-amber-100",
  teal: "bg-teal-100 text-teal-800 hover:bg-teal-100",
  indigo: "bg-indigo-100 text-indigo-800 hover:bg-indigo-100",
  yellow: "bg-yellow-100 text-yellow-800 hover:bg-yellow-100",
  emerald: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
  green: "bg-green-100 text-green-800 hover:bg-green-100",
  red: "bg-red-100 text-red-800 hover:bg-red-100",
};

export const WORK_ORDER_STATUSES = [
  { value: "pending", label: "Pendiente", tone: "slate" },
  { value: "in_progress", label: "En progreso", tone: "indigo" },
  { value: "paused", label: "En pausa", tone: "yellow" },
  { value: "completed", label: "Completada", tone: "emerald" },
  { value: "cancelled", label: "Cancelada", tone: "red" },
];

export const DIAGNOSIS_STATUSES = [
  { value: "pending", label: "Pendiente", tone: "slate" },
  { value: "in_progress", label: "En proceso", tone: "indigo" },
  { value: "completed", label: "Completado", tone: "emerald" },
];

export const PRIORITIES = [
  { value: "low", label: "Baja", tone: "slate" },
  { value: "normal", label: "Normal", tone: "blue" },
  { value: "high", label: "Alta", tone: "amber" },
  { value: "urgent", label: "Urgente", tone: "red" },
];

export const DIAGNOSIS_TYPES = [
  { value: "visual", label: "Visual" },
  { value: "mechanical", label: "Mecánico" },
  { value: "computerized", label: "Computarizado (escáner)" },
  { value: "road_test", label: "Prueba de camino" },
];

export const FUEL_LEVELS = [
  { value: "empty", label: "Vacío" },
  { value: "quarter", label: "1/4" },
  { value: "half", label: "1/2" },
  { value: "three_quarters", label: "3/4" },
  { value: "full", label: "Lleno" },
];

export const SERVICE_TYPES = [
  { value: "mantenimiento", label: "Mantenimiento" },
  { value: "reparacion", label: "Reparación" },
  { value: "revision", label: "Revisión" },
  { value: "diagnostico", label: "Diagnóstico" },
  { value: "hojalateria_pintura", label: "Hojalatería y pintura" },
  { value: "garantia", label: "Garantía" },
];

export const CHECKLIST_LEVEL = [
  { value: "good", label: "Bien" },
  { value: "regular", label: "Regular" },
  { value: "worn", label: "Desgastado" },
  { value: "poor", label: "Malo" },
];

export const BATTERY_LEVEL = [
  { value: "good", label: "Buena" },
  { value: "weak", label: "Débil" },
  { value: "dead", label: "Muerta" },
];

export const EVIDENCE_PHASES = [
  { value: "before", label: "Antes" },
  { value: "diagnostic", label: "Diagnóstico" },
  { value: "during", label: "Durante" },
  { value: "after", label: "Después" },
];

export const EVIDENCE_VISIBILITY = [
  { value: "internal", label: "Interno" },
  { value: "customer_visible", label: "Visible al cliente" },
];

export const EVIDENCE_TYPES = [
  { value: "photo", label: "Foto" },
  { value: "note", label: "Nota" },
  { value: "file", label: "Archivo" },
];

export function labelFrom(list, value) {
  const found = list.find((o) => o.value === value);
  return found ? found.label : value || "—";
}

export function toneFrom(list, value) {
  const found = list.find((o) => o.value === value);
  return found?.tone || "slate";
}

// ==== Fase 3 ====
export const QUOTE_STATUSES = [
  { value: "draft", label: "Borrador", tone: "slate" },
  { value: "sent", label: "Enviada", tone: "blue" },
  { value: "approved", label: "Aprobada", tone: "emerald" },
  { value: "rejected", label: "Rechazada", tone: "red" },
  { value: "expired", label: "Expirada", tone: "amber" },
  { value: "superseded", label: "Sustituida", tone: "yellow" },
];

export const PAYMENT_METHODS = [
  { value: "cash", label: "Efectivo" },
  { value: "card", label: "Tarjeta" },
  { value: "transfer", label: "Transferencia" },
  { value: "other", label: "Otro" },
];

export const SALE_STATUSES = [
  { value: "open", label: "Abierta", tone: "blue" },
  { value: "closed", label: "Cerrada", tone: "emerald" },
  { value: "cancelled", label: "Cancelada", tone: "red" },
];

export const QUOTE_LINE_TYPES = [
  { value: "part", label: "Refacción" },
  { value: "labor", label: "Mano de obra" },
  { value: "custom", label: "Otro concepto" },
];

export const STOCK_MOVEMENT_TYPES = [
  { value: "initial", label: "Existencia inicial" },
  { value: "purchase", label: "Compra" },
  { value: "sale", label: "Salida por venta" },
  { value: "adjustment", label: "Ajuste" },
  { value: "return", label: "Devolución" },
  { value: "transfer_in", label: "Transferencia entrada" },
  { value: "transfer_out", label: "Transferencia salida" },
];

// Fase 6.1 — Compras
export const PO_TYPES = [
  { value: "inventariable", label: "Inventariable" },
  { value: "servicio", label: "Servicio" },
  { value: "mixta", label: "Mixta" },
];

export const PO_STATUSES = [
  { value: "borrador", label: "Borrador", tone: "slate" },
  { value: "por_aprobar", label: "Por aprobar", tone: "amber" },
  { value: "aprobada", label: "Aprobada", tone: "blue" },
  { value: "emitida", label: "Emitida", tone: "emerald" },
  { value: "recibida_parcial", label: "Recibida parcial", tone: "violet" },
  { value: "recibida", label: "Recibida", tone: "green" },
  { value: "rechazada", label: "Rechazada", tone: "red" },
  { value: "cancelada", label: "Cancelada", tone: "gray" },
];

export const PO_LINE_TYPES = [
  { value: "inventariable", label: "Inventariable" },
  { value: "servicio", label: "Servicio" },
];

export const PO_UNITS = [
  { value: "pza", label: "pza" },
  { value: "kit", label: "kit" },
  { value: "kg",  label: "kg" },
  { value: "lt",  label: "lt" },
  { value: "hr",  label: "hr" },
  { value: "servicio", label: "servicio" },
  { value: "m",   label: "m" },
  { value: "caja", label: "caja" },
];

export const PO_IVA_RATES = [
  { value: 0.0,  label: "0%" },
  { value: 0.08, label: "8%" },
  { value: 0.16, label: "16%" },
];

// Fase 6.4 — Devoluciones a proveedor
export const PR_STATUSES = [
  { value: "borrador",  label: "Borrador" },
  { value: "emitida",   label: "Emitida" },
  { value: "cancelada", label: "Cancelada" },
];

// Fase 6.5 — Documentos administrativos del proveedor
export const SUPPLIER_DOC_TYPES = [
  { value: "factura",      label: "Factura" },
  { value: "nota_credito", label: "Nota de crédito" },
  { value: "otro",         label: "Otro" },
];

export const SUPPLIER_DOC_STATUSES = [
  { value: "activo",    label: "Activo",    tone: "emerald" },
  { value: "cancelado", label: "Cancelado", tone: "red" },
];


export function money(n, currency = "MXN") {
  return new Intl.NumberFormat("es-MX", { style: "currency", currency }).format(Number(n || 0));
}
